export default "__VITE_ASSET__4ca76c92__"